import { render } from "./social-icons.vue?vue&type=template&id=58ebc0c7"
import script from "./social-icons.vue?vue&type=script&lang=js"
export * from "./social-icons.vue?vue&type=script&lang=js"

import "./social-icons.vue?vue&type=style&index=0&id=58ebc0c7&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__